import type {FinancialAid} from "@/components/Providers/JWTProvider.tsx";

type PricedCourseSection = {
    cost: number | null;
    costFree: number | null;
    costReduced: number | null;
};

export const buildRegistrationPrice = (
    course: PricedCourseSection | undefined,
    financialAid: FinancialAid,
    studentOverrideCost: number | null | undefined,
): number => {
    if (studentOverrideCost !== null && studentOverrideCost !== undefined) {
        return studentOverrideCost;
    }

    if (financialAid === "free" && course?.costFree !== null && course?.costFree !== undefined) {
        return course.costFree;
    }

    if (
        financialAid === "reduced" &&
        course?.costReduced !== null &&
        course?.costReduced !== undefined
    ) {
        return course.costReduced;
    }

    return course?.cost ?? 0;
};
